import { call, takeLatest, put, select } from 'redux-saga/effects'
import {
    actionTypes,
    getProfileSuccess,
    loginSuccess,
    updateProfileSuccess,
} from '../actions/accountActions'
import {
    setLoading,
    setLoadingInit,
    toggleLoginForm,
} from '../actions/appActions'
import { sendRequest } from '../services/apiService'
import { setObjectData, getObjectData } from '../utils/localStorageHelper'
import { AppConstants, StorageKeys } from '../constants'
import apiConfig from '../constants/apiConfig'

function* _register({ payload: { params, onDone } }) {
    yield put(setLoading(true))
    const response = yield call(sendRequest, apiConfig.account.register, params)
    yield put(setLoading(false))
    onDone && onDone(response)
}

// eslint-disable-next-line require-yield
function* _logout() {
    setObjectData(StorageKeys.userData, '', true)
}

function* _getProfile({ payload: { params, onDone } }) {
    const userData = getObjectData(StorageKeys.userData, true)
    if (!userData) {
        return
    }

    if (params?.loading) yield put(setLoadingInit(true))

    const response = yield call(sendRequest, apiConfig.account.profile, {})
    if (response?.success) {
        yield put(getProfileSuccess(response?.responseData?.data))
    } else {
        setObjectData(StorageKeys.userData, '', true)
    }

    if (params?.loading) yield put(setLoadingInit(false))
    onDone && onDone(response)
}

function* _updatePassword({ payload: { params, onDone } }) {
    yield put(setLoading(true))
    const response = yield call(
        sendRequest,
        apiConfig.account.updatePassword,
        params
    )
    yield put(setLoading(false))
    onDone && onDone(response)
}

function* _forgotPassword({ payload: { params, onDone } }) {
    yield put(setLoading(true))
    const response = yield call(
        sendRequest,
        apiConfig.account.forgotPassword,
        params
    )
    yield put(setLoading(false))
    onDone && onDone(response)
}

function* _resetPassword({ payload: { params, onDone } }) {
    yield put(setLoading(true))
    const response = yield call(
        sendRequest,
        apiConfig.account.resetPassword,
        params
    )
    if (response.success) {
        yield put(toggleLoginForm(true))
    }
    yield put(setLoading(false))
    onDone && onDone(response)
}

function* _updateProfile({ payload: { params, onDone } }) {
    yield put(setLoading(true))
    const response = yield call(
        sendRequest,
        apiConfig.account.updateProfile,
        params
    )

    if (response.success) {
        yield put(updateProfileSuccess(params))
    }
    yield put(setLoading(false))
    onDone && onDone(response)
}

function* _login({ payload: { params, onDone } }) {
    yield put(setLoading(true))
    const api = { ...apiConfig.account.login };
    api.headers.Authorization = `Basic ${window.btoa(`${AppConstants.clientId}:${AppConstants.clientSecret}`)}`;
    const response = yield call(sendRequest, api, params)
    const { responseData, success } = response

    if (success && responseData?.access_token) {
        yield put(loginSuccess())
        setObjectData(StorageKeys.userData, {
            ...responseData,
            token: responseData.access_token,
        }, true)

        const responseProfile = yield call(
            sendRequest,
            apiConfig.account.profile,
            {}
        )

        if (responseProfile?.success) {
            yield put(getProfileSuccess(responseProfile?.responseData?.data))
        }
    }

    onDone && onDone(response)
    yield put(setLoading(false))
}

function* _updateAddress({ payload: { params, onDone, onFailed } }) {
    yield put(setLoading(true))
    const { addressCheck, userAddress } = params
    let checkAddressSuccess = true

    if (addressCheck) {
        const { map_key_direction, region_google } = yield select(
            state => state.RestaurantReducer.settings.deliver_setting
        )

        const address = [
            addressCheck.addressNumber,
            addressCheck.street,
            addressCheck.city
        ].join(',')

        const resSearchLocation = yield call(
            sendRequest,
            apiConfig.order.searchLocation,
            {
                key: map_key_direction || ' ',
                sensor: false,
                language: 'en',
                address: `${address}+${region_google}`.replace(/ /g, '+'),
            }
        )

        checkAddressSuccess = resSearchLocation?.responseData?.status === 'OK'
    }

    if (checkAddressSuccess) {
        // location valid
        const response = yield call(sendRequest, apiConfig.account.updateAddress, { userAddress: JSON.stringify(userAddress) })
        const { responseData, success } = response

        if (success && responseData?.result) {
            yield put({
                type: actionTypes.UPDATE_ADDRESS_SUCCESS,
                payload: userAddress
            })
            onDone && onDone(response)
        } else {
            onFailed && onFailed('addressMgr.mesUpdateAddressFailed')
        }
    } else {
        // location invalid
        onFailed && onFailed('addressMgr.mesAddressInvalid')
    }

    yield put(setLoading(false))
}

const sagas = [
    takeLatest(actionTypes.RESGISTER, _register),
    takeLatest(actionTypes.LOGIN, _login),
    takeLatest(actionTypes.UPDATE_PROFILE, _updateProfile),
    takeLatest(actionTypes.UPDATE_PASSWORD, _updatePassword),
    takeLatest(actionTypes.FOTGOT_PASSWORD, _forgotPassword),
    takeLatest(actionTypes.GET_PROFILE, _getProfile),
    takeLatest(actionTypes.LOGOUT, _logout),
    takeLatest(actionTypes.RESET_PASSWORD, _resetPassword),
    takeLatest(actionTypes.UPDATE_ADDRESS, _updateAddress),
]

export default sagas
